/**
 * Fluid Framework utilities for the Datapad application.
 */
import { type ContainerSchema, SharedTree } from 'fluid-framework';

/**
 * The Fluid container schema used by the Datapad.
 */
export const containerSchema: ContainerSchema = {
	initialObjects: { tree: SharedTree },
	dynamicObjectTypes: [SharedTree],
};
